<template>
    <div class="p-4 bg-white rounded-[19px] shadow flex-col justify-start items-start gap-3 inline-flex sm:p-6">
        <div class="text-slate-700 text-xl font-extrabold">Errors</div>

        <div class="flex flex-col gap-4 w-full">
            <div
                v-for="(err, index) in errors"
                :key="index"
                class="w-full px-5 py-3 bg-rose-50 rounded-2xl border border-solid border-rose-200"
            >
                <div class="text-rose-700 text-sm font-medium mb-1">
                    {{ err.message || 'Unknown error' }}
                </div>
                <div v-if="hasContext(err.context)" class="mt-2">
                    <button class="text-xs text-slate-500 underline cursor-pointer mb-1" @click="toggleContext(index)">
                        {{ expandedContexts[index] ? 'Hide context' : 'Show context' }}
                    </button>
                    <div
                        v-if="expandedContexts[index]"
                        class="mt-1 px-3 py-2 bg-white rounded-lg border border-solid border-rose-100 text-slate-500 text-xs break-all"
                    >
                        {{ JSON.stringify(err.context, null, 2) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive } from 'vue';
import type { IntegrationLogEntry } from '~/services/integrationLogsClient';

interface LogError {
    message?: string;
    context?: Record<string, unknown>;
    [key: string]: unknown;
}

const props = defineProps<{
    entry: IntegrationLogEntry;
}>();

const errors = computed<LogError[]>(() => {
    if (!Array.isArray(props.entry.errors)) {
        return [];
    }

    return props.entry.errors as LogError[];
});

const expandedContexts = reactive<Record<number, boolean>>({});

function hasContext(context: unknown): boolean {
    if (!context) {
        return false;
    }
    if (Array.isArray(context)) {
        return context.length > 0;
    }
    if (typeof context === 'object') {
        return Object.keys(context as object).length > 0;
    }
    return true;
}

function toggleContext(index: number): void {
    expandedContexts[index] = !expandedContexts[index];
}
</script>
